module.exports = {
      id: "mynews-usage",
      viewBox: "0 0 13.581 13.581",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#mynews",
      toString: function () {
        return this.url;
      }
    }